import { Component } from 'react';
import { connect } from 'react-redux';
import { getAdminFeatureToggles } from '../../../../actions/feature-toggles';
import PageTitle from '../../../common/page-title';
import FeatureTogglesTable from './feature-toggles-table';

class FeatureTogglesList extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getAdminFeatureToggles());
  }

  render() {
    const { isLoading, featureToggles } = this.props;

    return (
      <div className="container-fluid">
        <PageTitle>Feature Toggles</PageTitle>
        {isLoading && 'Loading...'}
        <FeatureTogglesTable featureToggles={featureToggles} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: !state.featureToggles.fetched && state.featureToggles.fetching,
  featureToggles: state.featureToggles.featureToggles,
});

export default connect(mapStateToProps)(FeatureTogglesList);
